/**
 * Tab switching fix for header drawer
 * This enhances the existing header-drawer.js with proper tab state management
 */

// Wait for the original header-drawer to be defined
document.addEventListener('DOMContentLoaded', () => {
  // Add tab switching logic to existing header-drawer components
  const headerDrawers = document.querySelectorAll('header-drawer');
  
  headerDrawers.forEach(drawer => {
    setupTabSwitching(drawer);
  });
});

function setupTabSwitching(drawer) {
  let currentOpenTab = null;
  let isAnimating = false;
  
  // Get all main tabs (Shop, About, Account) - only the TOP LEVEL ones
  const mainTabs = drawer.querySelectorAll('.parent-menu');
  
  // Override the click handlers for main tabs ONLY
  mainTabs.forEach((tab, index) => {
    // Get ONLY the direct child summary (not nested ones)
    const summary = tab.querySelector(':scope > summary');
    if (!summary) return;
    
    // Remove the original click handler and add our custom one
    const newSummary = summary.cloneNode(true);
    summary.parentNode.replaceChild(newSummary, summary);
    
    newSummary.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (isAnimating) return;
      
      switchToTab(tab, index);
    });
  });
  
  // Don't interfere with sub-menu accordions - let the original header-drawer.js handle them
  
  // Initialize first tab as open
  if (mainTabs.length > 0) {
    setTimeout(() => {
      switchToTab(mainTabs[0], 0, false); // Open without animation
    }, 100);
  }
  
  function switchToTab(targetTab, tabIndex, animate = true) {
    if (targetTab === currentOpenTab) return;
    
    isAnimating = true;
    
    // Close current tab
    if (currentOpenTab) {
      closeTab(currentOpenTab, animate);
    }
    
    // Open new tab after brief delay
    setTimeout(() => {
      openTab(targetTab, animate);
      currentOpenTab = targetTab;
      isAnimating = false;
    }, animate ? 200 : 0);
  }
  
  function openTab(tab, animate = true) {
    const summary = tab.querySelector('summary');
    const submenu = tab.querySelector('.menu-drawer__submenu');
    
    if (!summary || !submenu) return;
    
    // Set attributes
    tab.setAttribute('open', '');
    tab.classList.add('menu-open');
    summary.setAttribute('aria-expanded', 'true');
    
    if (animate) {
      // Animate in
      submenu.style.transform = 'translateX(-5%)';
      submenu.style.visibility = 'hidden';
      submenu.style.opacity = '0';
      submenu.style.transition = 'transform 0.3s ease, opacity 0.3s ease, visibility 0.3s ease';
      
      requestAnimationFrame(() => {
        submenu.style.transform = 'translateX(0)';
        submenu.style.visibility = 'visible';
        submenu.style.opacity = '1';
      });
    } else {
      // Show immediately
      submenu.style.transform = 'translateX(0)';
      submenu.style.visibility = 'visible';
      submenu.style.opacity = '1';
      submenu.style.transition = '';
    }
  }
  
  function closeTab(tab, animate = true) {
    const summary = tab.querySelector('summary');
    const submenu = tab.querySelector('.menu-drawer__submenu');
    
    if (!summary || !submenu) return;
    
    // Close any open sub-accordions
    const openSubMenus = tab.querySelectorAll('.in-accordion[open]');
    openSubMenus.forEach(subMenu => {
      subMenu.removeAttribute('open');
      const subSummary = subMenu.querySelector('summary');
      if (subSummary) {
        subSummary.setAttribute('aria-expanded', 'false');
      }
    });
    
    if (animate) {
      // Animate out
      submenu.style.transition = 'transform 0.3s ease, opacity 0.3s ease, visibility 0.3s ease';
      submenu.style.transform = 'translateX(-5%)';
      submenu.style.opacity = '0';
      
      setTimeout(() => {
        submenu.style.visibility = 'hidden';
        tab.removeAttribute('open');
        tab.classList.remove('menu-open');
        summary.setAttribute('aria-expanded', 'false');
      }, 300);
    } else {
      // Hide immediately
      submenu.style.visibility = 'hidden';
      submenu.style.opacity = '0';
      submenu.style.transform = 'translateX(-5%)';
      tab.removeAttribute('open');
      tab.classList.remove('menu-open');
      summary.setAttribute('aria-expanded', 'false');
    }
  }
  
  // Also handle drawer close - reset tabs
  const drawerElement = drawer.querySelector('details');
  if (drawerElement) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (!drawerElement.hasAttribute('open')) {
            // Drawer closed - reset tabs
            mainTabs.forEach(tab => {
              closeTab(tab, false);
            });
            currentOpenTab = null;
          } else {
            // Drawer opened - ensure first tab is open
            if (!currentOpenTab && mainTabs.length > 0) {
              setTimeout(() => {
                switchToTab(mainTabs[0], 0, false);
              }, 100);
            }
          }
        }
      });
    });
    
    observer.observe(drawerElement, { attributes: true });
  }
}